import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import { CodeValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';

interface IProps extends IAddEditFormProps<any> {
  selectedRows: any;
}

const AddEditCodeForm = ({
  id,
  initialValues,
  isLoading,
  submitHandler,
  onModalClosed,
  selectedRows,
}: IProps) => {
  return (
    <>
      <Formik
        initialValues={{ CodeName: '' }}
        enableReinitialize
        validationSchema={CodeValidateSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          submitHandler({
            CodeName: values.CodeName,
          });
        }}
      >
        {() => {
          return (
            <Form className="user-form">
              {isLoading && <FormLoader loading={isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={false}
                        label="code"
                      />
                      <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="CodeName"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={id}
                onModalClosed={onModalClosed}
                isLoading={isLoading}
                saveNextBtn={id > 0 ? 'update' : 'save'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddEditCodeForm;
